/* eslint-disable */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBQlgjrJx4E5MXsFTFLlEoZnBehPnGz7v0",
  authDomain: "wisecity-web.firebaseapp.com",
  projectId: "wisecity-web",
  storageBucket: "wisecity-web.appspot.com",
  messagingSenderId: "790965869654",
  appId: "1:790965869654:web:1d35356eee617617402ff7",
  measurementId: "G-FH0ZZQCQ5M"
};

const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp
